import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import styles from './styles';

interface IEmptyBody {
  onNewAttribute: () => void;
}

const EmptyBody = ({ onNewAttribute }: IEmptyBody) => {
  const clases = styles();
  return (
    <Box
      className={clases.root}
      alignItems="center"
      justifyContent="center"
      display="flex"
      height="75vh"
      flexDirection="column"
    >
      <Info className={clases.infoIcon} />
      <Typography className={clases.noAttributesTitle}>
        No Attributes
      </Typography>
      <Typography className={clases.noAttributesSubTitle}>
        Seems that there is nothing here yet.
      </Typography>
      <Button
        variant="contained"
        className={clases.addNewDarkButton}
        onClick={onNewAttribute}
      >
        Add New Attribute
      </Button>
    </Box>
  );
};

export default EmptyBody;
